import React from 'react';
import PropTypes from 'prop-types';

import { ArrowRight } from '../../collector/icon/ArrowRight';
import { identityModel } from '../../../redux-modules/base/models';

import './fair-interactive-map-details.css';

function FairInteractiveMapDetails({ exhibitor, artworks }) {
  if (!exhibitor) {
    return null;
  }

  return (
    <div className="fair-interactive-map-exhibitor-details">
      <div className="fair-interactive-map-exhibitor-details-title">{exhibitor.title}</div>
      <div className="fair-interactive-map-exhibitor-details-stand-number">
        Stand
        {' '}
        {exhibitor.standNumber}
      </div>
      {exhibitor.image && (
        <img
          className="fair-interactive-map-exhibitor-details-image"
          src={exhibitor.image}
          alt={exhibitor.title}
        />
      )}
      {artworks && artworks.length > 0 && (
        <div className="fair-interactive-map-exhibitor-details-artworks">
          <div className="fair-interactive-map-exhibitor-details-artworks-title">
            Featured artworks
          </div>
          {(artworks || []).map((artwork) => (
            <a
              key={artwork.id}
              className="fair-interactive-map-exhibitor-details-artworks-artwork"
              href={artwork.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {artwork.image && (
                <img
                  className="fair-interactive-map-exhibitor-details-artworks-artwork__image"
                  src={artwork.image}
                  alt={artwork.title}
                />
              )}
              <div className="fair-interactive-map-exhibitor-details-artworks-artwork__content">
                <div className="fair-interactive-map-exhibitor-details-artworks-artwork__content__artist">
                  {artwork.artist}
                </div>
                <div className="fair-interactive-map-exhibitor-details-artworks-artwork__content__title">
                  {[artwork.title, artwork.year].filter(Boolean).join(' | ')}
                </div>
                <div className="fair-interactive-map-exhibitor-details-artworks-artwork__content__stand-number">
                  Stand
                  {' '}
                  {exhibitor.standNumber}
                </div>
              </div>
              <div className="fair-interactive-map-exhibitor-details-artworks-artwork__arrow">
                <ArrowRight />
              </div>
            </a>
          ))}
        </div>
      )}
      {exhibitor.url && (
        <a
          className="fair-interactive-map-exhibitor-details-url"
          href={exhibitor.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          More about this exhibitor
        </a>
      )}
    </div>
  );
}

export { FairInteractiveMapDetails };

FairInteractiveMapDetails.propTypes = {
  exhibitor: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
    standNumber: identityModel,
    image: PropTypes.string,
  }),
  artworks: PropTypes.arrayOf(PropTypes.shape({
    id: identityModel,
    url: PropTypes.string,
    title: PropTypes.string,
    artist: PropTypes.string,
    image: PropTypes.string,
  })),
};

FairInteractiveMapDetails.defaultProps = {
  exhibitor: null,
  artworks: [],
};
